<template>
  <ion-modal
      :is-open="visible"
      @didDismiss="$emit('cancel')"
      class="biometric-modal"
  >
    <div class="ion-padding ion-text-center">
      <h3>{{ $t(title) }}</h3>
      <p>{{ $t(message) }}</p>

      <div v-if="error" class="ion-margin-bottom">
        <ion-text color="danger">
          <small>{{ $t(error) }}</small>
        </ion-text>
      </div>

      <ion-button
          expand="block"
          @click="$emit('confirm')"
          :disabled="loading"
      >
        <ion-spinner v-if="loading" name="crescent"/>
        <span v-else>{{ $t('biometric.modal.approve') }}</span>
      </ion-button>

      <ion-button
          fill="clear"
          expand="block"
          @click="$emit('cancel')"
          :disabled="loading"
      >
        {{ $t('biometric.modal.decline') }}
      </ion-button>
    </div>
  </ion-modal>
</template>

<script setup lang="ts">
import { IonButton, IonModal, IonSpinner, IonText } from '@ionic/vue';

defineProps<{
  visible: boolean;
  title: string;     // This is now always a KEY (e.g. 'biometric.defaults.title')
  message: string;   // This is now always a KEY
  loading: boolean;
  error: string | null; // This is now always a KEY or null
}>();

defineEmits(['confirm', 'cancel']);
</script>

<style scoped>
.biometric-modal {
  --height: auto;
  --width: 90%;
  --border-radius: 16px;
}
</style>